import * as React from "react"
import { cn } from "cn"

type PortraitCardProps = React.ComponentProps<"article"> & {
  portrait: React.ReactNode
  identity: React.ReactNode
  controls?: React.ReactNode
  status?: React.ReactNode
  compact?: boolean
  avatarRef?: React.Ref<HTMLDivElement>
}

/** Keep the renderer mounted when work opens; only its presentation changes. */
function PortraitCard({ portrait, identity, controls, status, compact = false, avatarRef, className, ...props }: PortraitCardProps) {
  return (
    <article data-slot="portrait-card" data-compact={compact} className={cn(
      "relative min-w-0",
      compact ? "min-h-28 pr-32" : "aspect-[3/4] w-full overflow-hidden rounded-3xl border border-border bg-background",
      className
    )} {...props}>
      <div ref={avatarRef} data-slot="conversation-avatar" data-presentation={compact ? "corner" : "portrait"} className={cn(
        "overflow-hidden bg-background",
        compact ? "fixed right-4 bottom-[max(1rem,env(safe-area-inset-bottom))] z-40 size-24 rounded-full border border-border sm:size-28" : "absolute inset-0"
      )}>{portrait}</div>
      <div data-slot="portrait-identity" className={cn("min-w-0 text-left", compact ? "relative" : "absolute inset-x-0 top-0 bg-background/95 px-4 py-3")}>
        {identity}
      </div>
      <div data-slot="conversation-controls" className={cn(
        "min-w-0 space-y-2",
        compact ? "relative mt-3" : "absolute inset-x-0 bottom-0 bg-background/95 px-3 py-3"
      )}>
        {status && <div role="status" className="text-center text-xs text-muted-foreground">{status}</div>}
        <div className="flex flex-wrap items-center justify-center gap-2 [&_button]:max-w-full [&_button]:whitespace-normal">{controls}</div>
      </div>
    </article>
  )
}

export { PortraitCard }
export type { PortraitCardProps }
